const BASE_URL = "https://api.themoviedb.org/3";
const IMAGE_BASE_URL = "https://image.tmdb.org/t/p";

const getHeaders = () => ({
  Authorization: `Bearer ${import.meta.env.VITE_TMDB_ACCESS_TOKEN}`,
  "Content-Type": "application/json",
});

export const getImageUrl = (path, size = "w500") => {
  if (!path) return null;
  return `${IMAGE_BASE_URL}/${size}${path}`;
};

export const searchMovies = async (query, page = 1) => {
  try {
    const response = await fetch(`${BASE_URL}/search/movie?query=${encodeURIComponent(query)}&page=${page}&language=es-ES`, { headers: getHeaders() });
    if (!response.ok) throw new Error("Error searching movies");
    return await response.json();
  } catch (error) {
    console.error("Error searching movies:", error);
    throw error;
  }
};

export const getMovieDetails = async (movieId) => {
  try {
    const response = await fetch(`${BASE_URL}/movie/${movieId}?language=es-ES&append_to_response=credits,videos,similar`, { headers: getHeaders() });
    if (!response.ok) throw new Error("Error fetching movie details");
    return await response.json();
  } catch (error) {
    console.error("Error fetching movie details:", error);
    throw error;
  }
};

export const getTrendingMovies = async (timeWindow = "week") => {
  try {
    const response = await fetch(`${BASE_URL}/trending/movie/${timeWindow}?language=es-ES`, { headers: getHeaders() });
    if (!response.ok) throw new Error("Error fetching trending movies");
    return await response.json();
  } catch (error) {
    console.error("Error fetching trending movies:", error);
    throw error;
  }
};

export const getPopularMovies = async (page = 1) => {
  try {
    const response = await fetch(`${BASE_URL}/movie/popular?page=${page}&language=es-ES`, { headers: getHeaders() });
    if (!response.ok) throw new Error("Error fetching popular movies");
    return await response.json();
  } catch (error) {
    console.error("Error fetching popular movies:", error);
    throw error;
  }
};

export const getTopRatedMovies = async (page = 1) => {
  try {
    const response = await fetch(`${BASE_URL}/movie/top_rated?page=${page}&language=es-ES`, { headers: getHeaders() });
    if (!response.ok) throw new Error("Error fetching top rated movies");
    return await response.json();
  } catch (error) {
    console.error("Error fetching top rated movies:", error);
    throw error;
  }
};

export const getUpcomingMovies = async (page = 1) => {
  try {
    const response = await fetch(`${BASE_URL}/movie/upcoming?page=${page}&language=es-ES`, { headers: getHeaders() });
    if (!response.ok) throw new Error("Error fetching upcoming movies");
    return await response.json();
  } catch (error) {
    console.error("Error fetching upcoming movies:", error);
    throw error;
  }
};

export const getGenres = async () => {
  try {
    const response = await fetch(`${BASE_URL}/genre/movie/list?language=es-ES`, { headers: getHeaders() });
    if (!response.ok) throw new Error("Error fetching genres");
    return await response.json();
  } catch (error) {
    console.error("Error fetching genres:", error);
    throw error;
  }
};

export const discoverMovies = async (params = {}) => {
  try {
    const queryParams = new URLSearchParams({
      language: "es-ES",
      ...params,
    });
    const response = await fetch(`${BASE_URL}/discover/movie?${queryParams}`, { headers: getHeaders() });
    if (!response.ok) throw new Error("Error discovering movies");
    return await response.json();
  } catch (error) {
    console.error("Error discovering movies:", error);
    throw error;
  }
};

export const getWatchProviders = async (movieId, country = "ES") => {
  try {
    const response = await fetch(`${BASE_URL}/movie/${movieId}/watch/providers`, { headers: getHeaders() });
    if (!response.ok) throw new Error("Error fetching watch providers");
    const data = await response.json();
    return data.results?.[country] || null;
  } catch (error) {
    console.error("Error fetching watch providers:", error);
    return null;
  }
};

export const getMovieVideos = async (movieId) => {
  try {
    // Fetch videos without language filter to get original language trailers
    const response = await fetch(`${BASE_URL}/movie/${movieId}/videos`, { headers: getHeaders() });
    if (!response.ok) throw new Error("Error fetching movie videos");
    const data = await response.json();
    return data.results || [];
  } catch (error) {
    console.error("Error fetching movie videos:", error);
    return [];
  }
};
